import { render, staticRenderFns } from "./ZinnesView.vue?vue&type=template&id=1e27849b&scoped=true"
import script from "./ZinnesView.vue?vue&type=script&lang=js"
export * from "./ZinnesView.vue?vue&type=script&lang=js"
import style0 from "./ZinnesView.vue?vue&type=style&index=0&id=1e27849b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e27849b",
  null
  
)

export default component.exports